export default __webpack_public_path__ + "static/media/shohailZindaniAbout.4fb961b7.png";